import Reveal from './lib/reveal';
import './scss/competition.scss';

Reveal.createFromSelector('.js-reveal');
